module.exports = __webpack_public_path__ + "img/Oiltanking_South-America_Argentina_Puerto-Rosales_Building-Outside_2012-01-24_6584.d9b719f0.jpg";